"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _FormBlock = _interopRequireDefault(require("../../components/FormBlock"));
var _FieldBlock = _interopRequireDefault(require("../../components/FieldBlock"));
var _TextBlock = _interopRequireDefault(require("../../components/TextBlock"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _ShowConditionsBlock = _interopRequireWildcard(require("./ShowConditionsBlock"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _notification = _interopRequireDefault(require("cccisd-icons/notification2"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _style = _interopRequireDefault(require("./style.css"));
var _common = _interopRequireDefault(require("../../styles/common.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var segmentSizeOptions = [{
  value: 'xsmall',
  label: 'Extra small'
}, {
  value: 'small',
  label: 'Small'
}, {
  value: 'normal',
  label: 'Normal'
}, {
  value: 'large',
  label: 'Large'
}, {
  value: 'xlarge',
  label: 'Extra large'
}, {
  value: 'custom',
  label: 'Custom'
}];
var _default = exports["default"] = function _default(_ref) {
  var _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? [] : _ref$fields,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function () {} : _ref$validate,
    _ref$initialValues = _ref.initialValues,
    initialValues = _ref$initialValues === void 0 ? {} : _ref$initialValues,
    _ref$withTemplate = _ref.withTemplate,
    withTemplate = _ref$withTemplate === void 0 ? false : _ref$withTemplate,
    _ref$withBubbleMessag = _ref.withBubbleMessages,
    withBubbleMessages = _ref$withBubbleMessag === void 0 ? false : _ref$withBubbleMessag,
    _ref$withAdjustedPlay = _ref.withAdjustedPlayerSettings,
    withAdjustedPlayerSettings = _ref$withAdjustedPlay === void 0 ? false : _ref$withAdjustedPlay,
    _ref$withAccommodatio = _ref.withAccommodations,
    withAccommodations = _ref$withAccommodatio === void 0 ? false : _ref$withAccommodatio,
    _ref$withBlock = _ref.withBlock,
    withBlock = _ref$withBlock === void 0 ? false : _ref$withBlock,
    _ref$withVisibilityCo = _ref.withVisibilityConditions,
    withVisibilityConditions = _ref$withVisibilityCo === void 0 ? false : _ref$withVisibilityCo,
    _ref$withQuestionNumb = _ref.withQuestionNumbers,
    withQuestionNumbers = _ref$withQuestionNumb === void 0 ? false : _ref$withQuestionNumb,
    _ref$withDefaultValue = _ref.withDefaultValueFromVariable,
    withDefaultValueFromVariable = _ref$withDefaultValue === void 0 ? false : _ref$withDefaultValue;
  var getFields = function getFields() {
    var formFields = fields;
    formFields = [].concat(_toConsumableArray(formFields), ['isPrintExpanded', 'printPlaceholder', 'printOverrideDefault', 'printSkip']);
    formFields = [].concat(_toConsumableArray(formFields), ['segmentSize', 'customSegmentSize', 'segmentTooltip']);
    if (withTemplate) {
      formFields = [].concat(_toConsumableArray(formFields), ['template', 'templateSettings', 'isTemplateExpanded']);
    }
    if (withBubbleMessages) {
      formFields = [].concat(_toConsumableArray(formFields), ['bubbleMessages[].id', 'bubbleMessages[].text', 'bubbleMessagesExpanded']);
    }
    if (withAdjustedPlayerSettings) {
      formFields = [].concat(_toConsumableArray(formFields), ['isAdjustedPlayerSettings', 'adjustedPlayerSettings', 'adjustedPlayerSettingsExpanded']);
    }
    if (withAccommodations) {
      formFields = [].concat(_toConsumableArray(formFields), ['isAccommodationsExpanded', 'overrideAccommodations', 'accommodations.masking', 'accommodations.highlighting', 'accommodations.autoplayQuestions', 'accommodations.autoplayChoices', 'accommodations.autoplayInstructions', 'accommodations.blockUserInteractions']);
    }
    if (withBlock) {
      formFields = [].concat(_toConsumableArray(formFields), ['blockIsSeparatePage', 'blockPlayerTemplate', 'blockPlayerTemplateSettings', 'blockIsPlayerTemplateExpanded', 'isAdjustedPlayerSettings', 'adjustedPlayerSettings']);
    }
    if (withVisibilityConditions) {
      formFields = [].concat(_toConsumableArray(formFields), ['showConditionsExpanded', 'showConditionsRules']);
    }
    if (withQuestionNumbers) {
      formFields = [].concat(_toConsumableArray(formFields), ['questionNumbersExpanded',
      // We use "hide" instead of "show" because we have to have default value as null
      // And we'd like to show numbers by default
      // It could be changed if we update initial values for existing components
      'questionNumbersHide', 'questionNumbersReset', 'questionNumbersResetNumber']);
    }
    if (withDefaultValueFromVariable) {
      formFields = [].concat(_toConsumableArray(formFields), ['defaultValueVariable', 'defaultValueVariableExpanded']);
    }
    return formFields;
  };
  var getInitialValues = function getInitialValues() {
    var formInitialValues = initialValues;
    if (withTemplate) {
      formInitialValues = _objectSpread(_objectSpread({}, formInitialValues), {}, {
        template: '',
        templateSettings: {},
        isTemplateExpanded: false
      });
    }
    if (withAdjustedPlayerSettings) {
      formInitialValues = _objectSpread(_objectSpread({}, formInitialValues), {}, {
        isAdjustedPlayerSettings: false,
        adjustedPlayerSettingsExpanded: false
      });
    }
    return formInitialValues;
  };
  var getValidate = function getValidate(values) {
    var errors = validate(values) || {};
    if (withVisibilityConditions) {
      errors = _objectSpread(_objectSpread({}, errors), (0, _ShowConditionsBlock.validate)(values));
    }
    if (withQuestionNumbers) {
      if (!values.questionNumbersHide && values.questionNumbersReset && !(0, _isInt["default"])(values.questionNumbersResetNumber, {
        min: 1,
        max: 9999
      })) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          questionNumbersResetNumber: 'Enter whole number from 1 to 9999'
        });
      }
    }
    return errors;
  };
  return function (WrappedComponent) {
    var Form = /*#__PURE__*/function (_React$Component) {
      _inherits(Form, _React$Component);
      function Form() {
        var _this;
        _classCallCheck(this, Form);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _callSuper(this, Form, [].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
          timestamp: +new Date()
        });
        _defineProperty(_assertThisInitialized(_this), "_onTemplateChange", function (event) {
          var _this$props$fields = _this.props.fields,
            template = _this$props$fields.template,
            templateSettings = _this$props$fields.templateSettings;
          var newTemplateName = event.target.value;
          var newTemplate = (0, _find2["default"])(_this.props.availableTemplates, {
            name: newTemplateName
          });
          var newTemplateSettings = newTemplate ? newTemplate.defaultSettings : {};
          template.onChange(newTemplateName);
          templateSettings.onChange(newTemplateSettings);
        });
        _defineProperty(_assertThisInitialized(_this), "_renderTemplateBlock", function () {
          var _this$props$fields2 = _this.props.fields,
            template = _this$props$fields2.template,
            templateSettings = _this$props$fields2.templateSettings,
            isTemplateExpanded = _this$props$fields2.isTemplateExpanded;
          if (!template.value && !_this.props.showAdvancedSettings) {
            return null;
          }
          var templateSettingsComponent = null;
          if (template.value !== '') {
            var currentTemplate = (0, _find2["default"])(_this.props.availableTemplates, {
              name: template.value
            });
            if (currentTemplate) {
              var SettingsComponent = currentTemplate.settingsComponent;
              if (SettingsComponent) {
                templateSettingsComponent = /*#__PURE__*/_react["default"].createElement(SettingsComponent, {
                  initialValues: _objectSpread(_objectSpread({}, currentTemplate.defaultSettings), templateSettings.value),
                  onChange: templateSettings.onChange,
                  settings: _this.props.values,
                  children: _this.props.children,
                  DataConnectorsPicker: _this.props.DataConnectorsPicker
                });
              }
            }
          }
          return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Template",
            type: _this.props.formBlockType,
            show: isTemplateExpanded.value,
            handleClick: isTemplateExpanded.onChange
          }, _this.props.availableTemplates.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", null, "There are no templates available") : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            className: !templateSettingsComponent ? _common["default"].lastRow : ''
          }, /*#__PURE__*/_react["default"].createElement(_FieldBlock["default"], {
            field: template,
            label: "Template",
            comment: "Some templates could override element settings"
          }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(template), {
            className: "form-control",
            style: {
              width: 'auto'
            },
            onChange: _this._onTemplateChange
          }), /*#__PURE__*/_react["default"].createElement("option", {
            value: ""
          }, "-- Default --"), _this.props.availableTemplates.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("option", {
              value: item.name,
              key: item.name
            }, item.title);
          })))), templateSettingsComponent));
        });
        _defineProperty(_assertThisInitialized(_this), "_changeOverrideAccommodations", function (event) {
          var _this$props$fields3 = _this.props.fields,
            overrideAccommodations = _this$props$fields3.overrideAccommodations,
            _this$props$fields3$a = _this$props$fields3.accommodations,
            masking = _this$props$fields3$a.masking,
            highlighting = _this$props$fields3$a.highlighting,
            autoplayQuestions = _this$props$fields3$a.autoplayQuestions,
            autoplayChoices = _this$props$fields3$a.autoplayChoices,
            autoplayInstructions = _this$props$fields3$a.autoplayInstructions,
            blockUserInteractions = _this$props$fields3$a.blockUserInteractions;
          var list = [masking, highlighting, autoplayQuestions, autoplayChoices, autoplayInstructions, blockUserInteractions];
          overrideAccommodations.onChange(event);
          if (event.target.checked) {
            list.forEach(function (item) {
              var globalValue = Boolean((0, _get2["default"])(_this.props.flowSettings, item.name));
              item.onChange(globalValue);
            });
          }
        });
        _defineProperty(_assertThisInitialized(_this), "_renderAccommodationsBlock", function () {
          var _this$props$fields4 = _this.props.fields,
            isAccommodationsExpanded = _this$props$fields4.isAccommodationsExpanded,
            overrideAccommodations = _this$props$fields4.overrideAccommodations,
            _this$props$fields4$a = _this$props$fields4.accommodations,
            masking = _this$props$fields4$a.masking,
            highlighting = _this$props$fields4$a.highlighting,
            autoplayQuestions = _this$props$fields4$a.autoplayQuestions,
            autoplayChoices = _this$props$fields4$a.autoplayChoices,
            autoplayInstructions = _this$props$fields4$a.autoplayInstructions,
            blockUserInteractions = _this$props$fields4$a.blockUserInteractions;
          var list = [{
            field: autoplayQuestions,
            label: 'Autoplay question audio'
          }, {
            field: autoplayChoices,
            label: 'Autoplay choice audio'
          }, {
            field: masking,
            label: 'Mask choices and reveal them one at a time',
            tooltip: 'Autoplay choice audio is required for masking. Choices are covered and revealed one at a time while the choice audio is spoken aloud.',
            style: {
              marginLeft: '2em'
            }
          }, {
            field: autoplayInstructions,
            label: 'Autoplay instructions audio'
          }, {
            field: highlighting,
            label: 'Highlight currently spoken word on screen when playing audio',
            tooltip: 'As audio is played, either autoplayed on page load or when clicked, the currently spoken word is colored differently so the user can read along with the audio. Word timings are required to be set up for each element for highlighting to work for that element.'
          }, {
            field: blockUserInteractions,
            label: 'Block all user actions while autoplay audio is playing'
          }];
          return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Accommodations",
            type: _this.props.formBlockType,
            show: isAccommodationsExpanded.value,
            handleClick: isAccommodationsExpanded.onChange
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              margin: '0'
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "checkbox"
          }, (0, _domOnlyProps["default"])(overrideAccommodations), {
            checked: Boolean(overrideAccommodations.value),
            onChange: _this._changeOverrideAccommodations
          })), ' ', "Override accommodations")), overrideAccommodations.value && /*#__PURE__*/_react["default"].createElement("div", {
            className: _common["default"].lastRow
          }, /*#__PURE__*/_react["default"].createElement(_FieldBlock["default"], {
            field: masking,
            label: "New accommodations",
            style: {
              marginTop: '1em'
            }
          }, list.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: item.field.name,
              className: "checkbox",
              style: _objectSpread({
                margin: '0'
              }, item.style)
            }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
              type: "checkbox"
            }, (0, _domOnlyProps["default"])(item.field))), " ", item.label, ' ', item.tooltip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: item.tooltip
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "text-primary"
            }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))));
          }))));
        });
        _defineProperty(_assertThisInitialized(_this), "_getNewBubbleMessageId", function () {
          var bubbleMessages = _this.props.fields.bubbleMessages;
          var lastMessage = (0, _last2["default"])(bubbleMessages);
          if (lastMessage && lastMessage.id) {
            return lastMessage.id.value + 1;
          }
          return 1;
        });
        _defineProperty(_assertThisInitialized(_this), "_renderBubbleMessagesBlock", function () {
          var _this$props$fields5 = _this.props.fields,
            bubbleMessages = _this$props$fields5.bubbleMessages,
            bubbleMessagesExpanded = _this$props$fields5.bubbleMessagesExpanded;
          return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Bubble message",
            type: _this.props.formBlockType,
            show: bubbleMessagesExpanded.value,
            handleClick: bubbleMessagesExpanded.onChange
          }, bubbleMessages.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: item.id.value,
              className: _style["default"].bubbleMessage
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].bubbleText
            }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
              content: item.text.value,
              onChange: item.text.onChange
            })), /*#__PURE__*/_react["default"].createElement("a", {
              onClick: function onClick() {
                return bubbleMessages.removeField(index);
              },
              className: "text-danger"
            }, /*#__PURE__*/_react["default"].createElement("i", {
              className: "glyphicon glyphicon-remove"
            })));
          }), bubbleMessages.length === 0 && /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-default btn-sm",
            onClick: function onClick() {
              return bubbleMessages.addField({
                id: _this._getNewBubbleMessageId(),
                text: ''
              });
            }
          }, "Add message"));
        });
        _defineProperty(_assertThisInitialized(_this), "_renderAdjustedPlayerSettingsBlock", function () {
          var _this$props = _this.props,
            availablePlayerTemplates = _this$props.availablePlayerTemplates,
            currentPlayerTemplateName = _this$props.currentPlayerTemplateName,
            currentPlayerTemplateSettings = _this$props.currentPlayerTemplateSettings;
          var _this$props$fields6 = _this.props.fields,
            isAdjustedPlayerSettings = _this$props$fields6.isAdjustedPlayerSettings,
            adjustedPlayerSettings = _this$props$fields6.adjustedPlayerSettings,
            adjustedPlayerSettingsExpanded = _this$props$fields6.adjustedPlayerSettingsExpanded;
          var templateSettingsComponent;
          var playerTemplate = availablePlayerTemplates.find(function (item) {
            return item.name === currentPlayerTemplateName;
          });
          if (playerTemplate && playerTemplate.settingsComponent) {
            var SettingsComponent = playerTemplate.settingsComponent;
            templateSettingsComponent = /*#__PURE__*/_react["default"].createElement(SettingsComponent, {
              form: "adjustedPlayerSettings".concat(_this.state.timestamp),
              initialValues: (0, _merge2["default"])({}, playerTemplate.defaultSettings, currentPlayerTemplateSettings, adjustedPlayerSettings.value),
              baseValues: (0, _merge2["default"])({}, playerTemplate.defaultSettings, currentPlayerTemplateSettings),
              onChange: function onChange(values) {
                isAdjustedPlayerSettings.onChange(!(0, _isEmpty2["default"])(values));
                adjustedPlayerSettings.onChange(values);
              },
              showHighlightedFields: true,
              inSidebar: true
            });
          }
          var hasChanges = !(0, _isEmpty2["default"])(adjustedPlayerSettings.value);
          return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Page settings",
            type: _this.props.formBlockType,
            show: adjustedPlayerSettingsExpanded.value,
            handleClick: adjustedPlayerSettingsExpanded.onChange,
            focusOnFirstField: false
          }, hasChanges && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].resetWrapper
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "text-warning"
          }, /*#__PURE__*/_react["default"].createElement(_notification["default"], {
            spaceRight: true
          }), "This element will be on its own page"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-default",
            onClick: function onClick() {
              (0, _cccisdConfirm["default"])({
                message: 'Are you sure?',
                description: 'This will clear away all changes to Player Settings made to this element. Proceed?',
                confirmLabel: 'Reset Page Settings',
                abortLabel: 'Cancel'
              }).then(function () {
                adjustedPlayerSettings.onChange({});
              });
            }
          }, "Reset"))), templateSettingsComponent);
        });
        _defineProperty(_assertThisInitialized(_this), "_changeQuestionNumbersReset", function (event) {
          var _this$props$fields7 = _this.props.fields,
            questionNumbersReset = _this$props$fields7.questionNumbersReset,
            questionNumbersResetNumber = _this$props$fields7.questionNumbersResetNumber;
          questionNumbersReset.onChange(event);
          questionNumbersResetNumber.onChange('1');
        });
        _defineProperty(_assertThisInitialized(_this), "_renderQuestionNumbersBlock", function () {
          var _this$props$fields8 = _this.props.fields,
            questionNumbersExpanded = _this$props$fields8.questionNumbersExpanded,
            questionNumbersHide = _this$props$fields8.questionNumbersHide,
            questionNumbersReset = _this$props$fields8.questionNumbersReset,
            questionNumbersResetNumber = _this$props$fields8.questionNumbersResetNumber;
          return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Question numbers",
            type: _this.props.formBlockType,
            show: questionNumbersExpanded.value,
            handleClick: questionNumbersExpanded.onChange
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              margin: '0'
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            value: !questionNumbersHide.value,
            checked: !questionNumbersHide.value,
            onChange: function onChange() {
              return questionNumbersHide.onChange(!questionNumbersHide.value);
            }
          }), ' ', "Show numbers")), !questionNumbersHide.value && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              margin: '0'
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "checkbox"
          }, (0, _domOnlyProps["default"])(questionNumbersReset), {
            checked: !!questionNumbersReset.value,
            onChange: _this._changeQuestionNumbersReset
          })), ' ', "Reset to specific number")), questionNumbersReset.value && /*#__PURE__*/_react["default"].createElement("div", {
            className: _common["default"].lastRow,
            style: {
              marginTop: '0.5em'
            }
          }, /*#__PURE__*/_react["default"].createElement(_TextBlock["default"], {
            field: questionNumbersResetNumber,
            label: "Start number",
            inputStyle: {
              width: '60px'
            }
          }))));
        });
        _defineProperty(_assertThisInitialized(_this), "_onPlayerTemplateChange", function (event) {
          var _this$props$fields9 = _this.props.fields,
            blockIsSeparatePage = _this$props$fields9.blockIsSeparatePage,
            blockPlayerTemplate = _this$props$fields9.blockPlayerTemplate,
            blockPlayerTemplateSettings = _this$props$fields9.blockPlayerTemplateSettings;
          var newTemplateName = event.target.value;
          blockPlayerTemplate.onChange(newTemplateName);
          blockPlayerTemplateSettings.onChange({});
          blockIsSeparatePage.onChange(true);
        });
        _defineProperty(_assertThisInitialized(_this), "_renderBlockBlock", function () {
          var _this$props2 = _this.props,
            availablePlayerTemplates = _this$props2.availablePlayerTemplates,
            currentPlayerTemplateName = _this$props2.currentPlayerTemplateName,
            currentPlayerTemplateSettings = _this$props2.currentPlayerTemplateSettings;
          var _this$props$fields10 = _this.props.fields,
            blockIsSeparatePage = _this$props$fields10.blockIsSeparatePage,
            blockPlayerTemplate = _this$props$fields10.blockPlayerTemplate,
            blockPlayerTemplateSettings = _this$props$fields10.blockPlayerTemplateSettings,
            blockIsPlayerTemplateExpanded = _this$props$fields10.blockIsPlayerTemplateExpanded,
            isAdjustedPlayerSettings = _this$props$fields10.isAdjustedPlayerSettings,
            adjustedPlayerSettings = _this$props$fields10.adjustedPlayerSettings;
          var templateSettingsComponent;
          if (blockPlayerTemplate.value === '') {
            var playerTemplate = availablePlayerTemplates.find(function (item) {
              return item.name === currentPlayerTemplateName;
            });
            if (playerTemplate && playerTemplate.settingsComponent) {
              var SettingsComponent = playerTemplate.settingsComponent;
              var hasChanges = !(0, _isEmpty2["default"])(adjustedPlayerSettings.value);
              templateSettingsComponent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasChanges && /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].resetWrapper
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: "text-warning"
              }, /*#__PURE__*/_react["default"].createElement(_notification["default"], {
                spaceRight: true
              }), "This element will be on its own page"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
                type: "button",
                className: "btn btn-default",
                onClick: function onClick() {
                  (0, _cccisdConfirm["default"])({
                    message: 'Are you sure?',
                    description: 'This will clear away all changes to Player Settings made to this element. Proceed?',
                    confirmLabel: 'Reset Page Settings',
                    abortLabel: 'Cancel'
                  }).then(function () {
                    adjustedPlayerSettings.onChange({});
                  });
                }
              }, "Reset"))), /*#__PURE__*/_react["default"].createElement(SettingsComponent, {
                form: "adjustedBlockPlayerSettings".concat(_this.state.timestamp),
                initialValues: (0, _merge2["default"])({}, playerTemplate.defaultSettings, currentPlayerTemplateSettings, adjustedPlayerSettings.value),
                baseValues: (0, _merge2["default"])({}, playerTemplate.defaultSettings, currentPlayerTemplateSettings),
                onChange: function onChange(values) {
                  var hasValues = !(0, _isEmpty2["default"])(values);
                  isAdjustedPlayerSettings.onChange(hasValues);
                  adjustedPlayerSettings.onChange(values);
                  if (hasValues) {
                    blockIsSeparatePage.onChange(true);
                  }
                },
                showHighlightedFields: true,
                inSidebar: true
              }));
            }
          } else {
            var currentTemplate = availablePlayerTemplates.find(function (item) {
              return item.name === blockPlayerTemplate.value;
            });
            if (currentTemplate && currentTemplate.settingsComponent) {
              var _SettingsComponent = currentTemplate.settingsComponent;
              templateSettingsComponent = /*#__PURE__*/_react["default"].createElement(_SettingsComponent, {
                form: "blockTemplate".concat(_this.state.timestamp),
                initialValues: _objectSpread(_objectSpread({}, currentTemplate.defaultSettings), blockPlayerTemplateSettings.value),
                onChange: blockPlayerTemplateSettings.onChange
              });
            }
          }
          var showTemplateSelectbox = availablePlayerTemplates.length > 1 || blockPlayerTemplate.value !== '';
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: {
              marginTop: '0'
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "checkbox"
          }, (0, _domOnlyProps["default"])(blockIsSeparatePage), {
            disabled: blockPlayerTemplate.value !== '' || isAdjustedPlayerSettings.value
          })), ' ', "Insert page break before and after block")), /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Page settings",
            type: "primary",
            show: blockIsPlayerTemplateExpanded.value,
            handleClick: blockIsPlayerTemplateExpanded.onChange,
            focusOnFirstField: false
          }, showTemplateSelectbox && /*#__PURE__*/_react["default"].createElement("div", {
            className: !templateSettingsComponent ? _common["default"].lastRow : ''
          }, /*#__PURE__*/_react["default"].createElement(_FieldBlock["default"], {
            field: blockPlayerTemplate,
            label: "Change player template for this block"
          }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(blockPlayerTemplate), {
            className: "form-control",
            style: {
              width: 'auto'
            },
            onChange: _this._onPlayerTemplateChange
          }), /*#__PURE__*/_react["default"].createElement("option", {
            value: ""
          }, "-- inherited --"), availablePlayerTemplates.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("option", {
              value: item.name,
              key: item.name
            }, item.title);
          })))), templateSettingsComponent));
        });
        _defineProperty(_assertThisInitialized(_this), "_renderDefaultValueVariableBlock", function () {
          var defaultValues = _this.props.defaultValues;
          var _this$props$fields11 = _this.props.fields,
            defaultValueVariable = _this$props$fields11.defaultValueVariable,
            defaultValueVariableExpanded = _this$props$fields11.defaultValueVariableExpanded;
          var isHidden = ['basic', 'premium'].includes(_this.props.restrictionsLevel);
          if (isHidden) {
            return null;
          }
          return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Default value from variable",
            type: "primary",
            show: defaultValueVariableExpanded.value,
            handleClick: defaultValueVariableExpanded.onChange
          }, defaultValues.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", null, "There are no variables to pick") : /*#__PURE__*/_react["default"].createElement("select", _extends({
            className: "form-control"
          }, (0, _domOnlyProps["default"])(defaultValueVariable)), /*#__PURE__*/_react["default"].createElement("option", {
            value: ""
          }, "-- Pick variable --"), defaultValues.map(function (value) {
            return /*#__PURE__*/_react["default"].createElement("option", {
              key: value.handle,
              value: value.handle
            }, value.label);
          })));
        });
        _defineProperty(_assertThisInitialized(_this), "_renderPrintPlaceholderBlock", function () {
          var _this$props$fields12 = _this.props.fields,
            isPrintExpanded = _this$props$fields12.isPrintExpanded,
            printPlaceholder = _this$props$fields12.printPlaceholder,
            printOverrideDefault = _this$props$fields12.printOverrideDefault,
            printSkip = _this$props$fields12.printSkip;
          var hasPrintVersion = _this.props.elementType && _this.props.elementType.hasPrintVersion;
          return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Print view",
            type: "primary",
            show: isPrintExpanded.value,
            handleClick: isPrintExpanded.onChange
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: _objectSpread({
              marginTop: '0'
            }, printSkip.value || hasPrintVersion ? {
              marginBottom: 0
            } : {})
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            value: "true",
            checked: !printSkip.value,
            onChange: function onChange() {
              return printSkip.onChange(!printSkip.value);
            }
          }), ' ', "Show in PDF")), !printSkip.value && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasPrintVersion && /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox",
            style: _objectSpread({
              marginTop: '0'
            }, printOverrideDefault.value ? {} : {
              marginBottom: 0
            })
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            value: "true",
            checked: printOverrideDefault.value,
            onChange: function onChange() {
              return printOverrideDefault.onChange(!printOverrideDefault.value);
            }
          }), ' ', "Show custom content when printed")), (!hasPrintVersion || printOverrideDefault.value) && /*#__PURE__*/_react["default"].createElement(_FieldBlock["default"], {
            field: printPlaceholder,
            label: "Content to display in Print View",
            style: {
              margin: '0'
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
            content: printPlaceholder.value,
            onChange: printPlaceholder.onChange
          }))));
        });
        _defineProperty(_assertThisInitialized(_this), "_renderSegmentBlock", function () {
          var _this$props$fields13 = _this.props.fields,
            segmentSize = _this$props$fields13.segmentSize,
            customSegmentSize = _this$props$fields13.customSegmentSize,
            segmentTooltip = _this$props$fields13.segmentTooltip;
          var currentPlayerTemplateSettings = _this.props.currentPlayerTemplateSettings;
          if (!currentPlayerTemplateSettings.showProgressBar || !currentPlayerTemplateSettings.useSegmentedProgressBar) {
            return null;
          }
          return /*#__PURE__*/_react["default"].createElement(_FormBlock["default"], {
            title: "Progress Bar Segment",
            type: "primary"
          }, /*#__PURE__*/_react["default"].createElement(_FieldBlock["default"], {
            field: segmentSize,
            label: "Segment size"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].segmentSizeWrapper
          }, /*#__PURE__*/_react["default"].createElement("select", {
            className: "form-control",
            style: {
              width: 'auto'
            },
            value: segmentSize.value || 'normal',
            onChange: function onChange(e) {
              var value = e.target.value;
              segmentSize.onChange(e.target.value);
              if (value === 'custom') {
                customSegmentSize.onChange('100');
              }
            }
          }, segmentSizeOptions.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("option", {
              value: item.value,
              key: item.value
            }, item.label);
          })), segmentSize.value === 'custom' && /*#__PURE__*/_react["default"].createElement("div", {
            className: "input-group"
          }, /*#__PURE__*/_react["default"].createElement("input", {
            className: "form-control",
            name: "customSegmentSize",
            type: "text",
            value: customSegmentSize.value,
            onChange: customSegmentSize.onChange,
            style: {
              width: '6em'
            }
          }), /*#__PURE__*/_react["default"].createElement("span", {
            className: "input-group-addon"
          }, "% of normal")))), /*#__PURE__*/_react["default"].createElement("div", {
            className: _common["default"].lastRow
          }, /*#__PURE__*/_react["default"].createElement(_TextBlock["default"], {
            field: segmentTooltip,
            label: "Segment tooltip"
          })));
        });
        return _this;
      }
      _createClass(Form, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$props3 = this.props,
            valid = _this$props3.valid,
            values = _this$props3.values;
          if ((0, _isEqual2["default"])(prevProps.valid, valid) && (0, _isEqual2["default"])(prevProps.values, values)) {
            return;
          }
          if (!valid) {
            this.props.showPreviewError();
          } else {
            this.props.updatePreview(values);
          }
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(WrappedComponent, this.props), withDefaultValueFromVariable && this._renderDefaultValueVariableBlock(), withBubbleMessages && this._renderBubbleMessagesBlock(), withAdjustedPlayerSettings && this._renderAdjustedPlayerSettingsBlock(), withTemplate && this._renderTemplateBlock(), withAccommodations && this._renderAccommodationsBlock(), withBlock && this._renderBlockBlock(), withVisibilityConditions && /*#__PURE__*/_react["default"].createElement(_ShowConditionsBlock["default"], {
            fields: this.props.fields,
            formBlockType: this.props.formBlockType,
            DataConnectorsPicker: this.props.DataConnectorsPicker,
            getDataConnectorMeta: this.props.getDataConnectorMeta
          }), withQuestionNumbers && this._renderQuestionNumbersBlock(), this.props.elementType && !this.props.elementType.skipPlaying && this._renderPrintPlaceholderBlock(), this.props.isTopLevel && this._renderSegmentBlock());
        }
      }]);
      return Form;
    }(_react["default"].Component);
    _defineProperty(Form, "propTypes", {
      fields: _propTypes["default"].object.isRequired,
      valid: _propTypes["default"].bool,
      values: _propTypes["default"].object,
      updatePreview: _propTypes["default"].func,
      showPreviewError: _propTypes["default"].func,
      availableTemplates: _propTypes["default"].array,
      availablePlayerTemplates: _propTypes["default"].array,
      currentPlayerTemplateName: _propTypes["default"].string,
      currentPlayerTemplateSettings: _propTypes["default"].object,
      formBlockType: _propTypes["default"].string,
      children: _propTypes["default"].array,
      DataConnectorsPicker: _propTypes["default"].func,
      getDataConnectorMeta: _propTypes["default"].func,
      defaultValues: _propTypes["default"].array,
      elementType: _propTypes["default"].object,
      showAdvancedSettings: _propTypes["default"].bool
    });
    _defineProperty(Form, "defaultProps", {
      updatePreview: function updatePreview() {},
      showPreviewError: function showPreviewError() {},
      formBlockType: 'primary',
      availableTemplates: [],
      availablePlayerTemplates: [],
      getDataConnectorMeta: function getDataConnectorMeta() {},
      defaultValues: [],
      showAdvancedSettings: true
    });
    return (0, _reduxForm.reduxForm)({
      form: 'builderForm',
      fields: getFields(),
      validate: getValidate,
      initialValues: getInitialValues()
    })(Form);
  };
};